import dayjs from "dayjs";

const ORDER_V2_START_TIME = dayjs("2026-10-29 05:00:00").valueOf();

// 按订单创建时间分流：2026-10-29 05:00:00 起进入 V2，缺失或无效时间进入 V1。
export function getOrderDetailRouteName(createTime) {
  return dayjs(createTime || "").valueOf() >= ORDER_V2_START_TIME
    ? "OrderDetailV2"
    : "OrderDetail";
}
